/* storefront locale fixes v2 */
(() => {
  const locale = (document.documentElement.lang || '').slice(0, 2).toLowerCase();

  if (locale !== 'en') return;

  const replacements = new Map([
    ['iceCore', 'iceKore'],
    ['icecore', 'iceKore'],
    ['IceKore', 'iceKore'],
    ['Icekore', 'iceKore'],
    ['Stairs with hidden fridge', 'Stairs with hidden chiller'],
    ['Staircase with space for a refrigeration unit', 'Stairs with hidden chiller'],
    ['Thermolids', 'Insulated lid'],
    ['Thermolag', 'Insulated lid'],
    ['Farve', 'Color'],
    ['Trappe', 'Stairs'],
    ['Natur', 'Nature'],
    ['Standard Trin', 'Standard steps'],
    ['Trappe med køleskjuler', 'Stairs with hidden chiller'],
    ['Vores Mentale Sundhed-fordel', 'Our Mental Health offer'],
    ['Et premium isbad til mere ro, energi og et stærkere hverdagsritual', 'A premium ice bath for more calm, energy, and a stronger daily ritual'],
    ['Se tilbuddet', 'See the offer'],
    ['Cold plunge guides', 'Cold-water therapy guides'],
    ['Real people. Real cold-plunge enthusiasts.', 'Real people. Real ice-bath enthusiasts.'],
    ['På alle måder en positiv oplevelse!', 'An excellent experience from every angle.'],
    ['IceKore består tydeligvis af mennesker der selv er isbadere, og som har fokus på den gode oplevelse til nye og hærdede isbadere.', 'iceKore is clearly built by people who use ice baths themselves and care deeply about creating a great experience for both new and seasoned cold-water bathers.'],
    ['Kvaliteten af selve isbadet er i top, og det har været i brug dagligt ligesiden det blev sat op.', 'The quality is excellent, and it has been in daily use ever since it was installed.'],
    ['Filteret fungerer upåklageligt', 'The filter works flawlessly'],
    ['og appen er nem og funktionel', 'and the app is simple and reliable'],
    ['og app\'en er nem og funktionel', 'and the app is simple and reliable'],
    ['og sikrer at jeg hver morgen har et isbad med klart vand i præcis den temperatur jeg ønsker.', 'so every morning I step into clear water at exactly the temperature I want.'],
  ]);
  const widgetSelectors = [
    '.globo-swatch-product-detail',
    '.globo-product-groups-detail',
    'section-store--product-addons-block',
  ];
  const observedRoots = new WeakSet();

  const replaceText = (value) => {
    if (typeof value !== 'string') return value;

    let nextValue = value;

    replacements.forEach((replacement, source) => {
      if (nextValue.includes(source)) {
        nextValue = nextValue.split(source).join(replacement);
      }
    });

    return nextValue;
  };

  const translateTextNodes = (root) => {
    if (!root) return;

    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);

    while (walker.nextNode()) {
      const textNode = walker.currentNode;
      const parentTagName = textNode.parentElement?.tagName;

      if (parentTagName === 'SCRIPT' || parentTagName === 'STYLE' || parentTagName === 'NOSCRIPT') {
        continue;
      }

      const originalValue = textNode.nodeValue || '';
      const nextValue = replaceText(originalValue);

      if (nextValue !== originalValue) {
        textNode.nodeValue = nextValue;
      }
    }
  };

  const translateAttributes = (root) => {
    if (!root?.querySelectorAll) return;

    root.querySelectorAll('[aria-label], [title]').forEach((element) => {
      ['aria-label', 'title'].forEach((attributeName) => {
        const currentValue = element.getAttribute(attributeName);
        const nextValue = replaceText(currentValue);

        if (nextValue !== currentValue) {
          element.setAttribute(attributeName, nextValue);
        }
      });
    });
  };

  const collectShadowRoots = (root) => {
    if (!root?.querySelectorAll) return [];

    return [...root.querySelectorAll('*')]
      .map((element) => element.shadowRoot)
      .filter(Boolean);
  };

  const translateWidget = (widget) => {
    translateTextNodes(widget);
    translateAttributes(widget);
    collectShadowRoots(widget).forEach(translateWidget);
  };

  const translateWidgets = (scope = document) => {
    if (!scope?.querySelectorAll) return;
    scope.querySelectorAll(widgetSelectors.join(', ')).forEach(translateWidget);
  };

  const observeRoot = (root, observer) => {
    if (!root || observedRoots.has(root)) return;

    observedRoots.add(root);
    observer.observe(root, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['aria-label', 'title'],
    });

    collectShadowRoots(root).forEach((shadowRoot) => observeRoot(shadowRoot, observer));
  };

  const observer = new MutationObserver((mutations) => {
    const widgetsToUpdate = new Set();
    const rootsToObserve = new Set();

    mutations.forEach((mutation) => {
      const mutationTarget = mutation.target?.nodeType === Node.ELEMENT_NODE
        ? mutation.target
        : mutation.target?.parentElement;

      if (mutationTarget?.closest) {
        const parentWidget = mutationTarget.closest(widgetSelectors.join(', '));
        if (parentWidget) widgetsToUpdate.add(parentWidget);
      }

      mutation.addedNodes.forEach((node) => {
        if (node.nodeType !== Node.ELEMENT_NODE) return;

        if (node.matches?.(widgetSelectors.join(', '))) {
          widgetsToUpdate.add(node);
        }

        if (node.shadowRoot) {
          rootsToObserve.add(node.shadowRoot);
        }

        node.querySelectorAll?.(widgetSelectors.join(', ')).forEach((widget) => {
          widgetsToUpdate.add(widget);
        });

        node.querySelectorAll?.('*').forEach((element) => {
          if (element.shadowRoot) {
            rootsToObserve.add(element.shadowRoot);
          }
        });
      });
    });

    widgetsToUpdate.forEach(translateWidget);
    rootsToObserve.forEach((root) => {
      translateWidget(root);
      observeRoot(root, observer);
    });
  });

  const start = () => {
    translateWidgets();
    observeRoot(document.body, observer);

    [250, 1000, 2500].forEach((delay) => {
      window.setTimeout(translateWidgets, delay);
    });

    if (window.customElements?.whenDefined) {
      window.customElements.whenDefined('section-store--product-addons-block').then(() => {
        translateWidgets();
        window.setTimeout(translateWidgets, 250);
      });
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
    return;
  }

  start();
})();
